import { renderFoodMenuListVertical } from './food-menu-list-vertical.js';

/** @type {Record<string, (root: HTMLElement, config: Record<string, unknown>, feed: unknown[]) => void>} */
const RENDERERS = {
  'food.menu_list_vertical': renderFoodMenuListVertical,
};

/**
 * @param {HTMLElement} rootEl
 * @param {{ templateId?: string | null, templateConfig?: Record<string, unknown> | null, feedSnapshot?: unknown[] | null }} slot
 */
export function renderTemplateSlot(rootEl, slot) {
  const templateId = slot.templateId ?? '';
  const config =
    slot.templateConfig && typeof slot.templateConfig === 'object' ? slot.templateConfig : {};
  const feed = Array.isArray(slot.feedSnapshot) ? slot.feedSnapshot : [];
  const render = RENDERERS[templateId];
  if (!render) {
    const placeholder = document.createElement('div');
    placeholder.className = 'slot-unsupported';
    placeholder.textContent = `Template "${templateId}" non ancora supportato nel player`;
    rootEl.appendChild(placeholder);
    return;
  }
  render(rootEl, config, feed);
}
